// extracted by mini-css-extract-plugin
export default {"jana":"#f4e6d2","bonus":"Ax","bonus-header":"Ay","bonusHeader":"Ay"};